/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowRight, ArrowLeft } from 'icons';

import styled, { css } from 'styled-components';
import { FlexCenter, colors } from 'globalStyle';

const ArrowType = (props) => (
  <Arrow type={props.type} onClick={props.onClick}>
    { props.type === 'right'
      ? <ArrowRight color={props.isWhite ? colors.WHITE : colors.GRAY_1} />
      : <ArrowLeft color={props.isWhite ? colors.WHITE : colors.GRAY_1} /> }
  </Arrow>
);

export const Carousel = ({
  children, isCustomArrow, refCarousel, ...settings
}) => {
  if (isCustomArrow) {
    return (
      <Slider
        ref={refCarousel}
        {...settings}
      >
        {children}
      </Slider>
    );
  }

  return (
    <Slider
      ref={refCarousel}
      nextArrow={<ArrowType type="right" />}
      prevArrow={<ArrowType type="left" />}
      {...settings}
      style={{ marginLeft: 'auto', marginRight: 'auto' }}

    >
      {children}
    </Slider>
  );
};

export const Arrow = styled.div`
    ${FlexCenter}
    position: absolute;
    color: ${(props) => (props.isWhite ? colors.WHITE : colors.GRAY_1)};
    font-size: 1em;
    font-weight: bold;
    cursor: pointer;
    top: 0;
    bottom: 0;
    z-index: 0;
    ${(props) => (props.type === 'right' ? css`
        right: ${(props.isInside ? '0em' : '-2.2rem')};
    ` : css`
        left: ${(props.isInside ? '0.5em' : '-1.4rem')};
    `)}
`;
